import { useQuery } from '@tanstack/react-query';
import { AuthRepository } from 'features/auth/repositories/AuthRepository';

export const useAuthenticatedUser = () => {
  const repository = new AuthRepository();

  const { isFetched, data: user } = useQuery({
    queryKey: ['authenticatedUser'],
    queryFn: () => repository.getAuthenticatedUser(),
  });

  const isAuthenticated = !!user;

  return {
    isFetched,
    isAuthenticated,
    user,
  };
};
